import { styled } from '@mui/material';

import { Box, Button, Form, Icon, PasswordInput, Stack, Text } from 'shell/components';

const PasswordInputs = ({
    device = 'desktop',
    form,
    errors,
    satisfyRequirement,
    handlePrev,
    handleComplete,
    handleChange,
    PAGES,
}) => {
    return (
        <VerifyEmailBox device={device}>
            <Stack alignItems={'center'}>
                <Text variant={'h6'}>Nice to meet you {form.preferredName || form.firstName}!</Text>
                <Text variant={'p1'} align={'center'} sx={{ marginTop: 1 }}>
                    Next, let’s create a password to protect your account.
                </Text>
            </Stack>
            <Form onSubmit={() => handleComplete({ skip: false })}>
                <InputStack>
                    <PasswordInput
                        data-cy={'account-creation-enter-password'}
                        error={Boolean(errors.password)}
                        helperText={errors.password}
                        label={'Enter New Password'}
                        onChange={(e) => handleChange('password', e.target.value)}
                        placeholder={'Enter new password'}
                        autoComplete={'off'}
                        value={form.password}
                        required
                    />

                    <Stack sx={{ margin: (theme) => theme.spacing(2, 0, 6, 0) }}>
                        <Text variant={'p3'}>The password must have:</Text>
                        <Text
                            variant={'p3'}
                            color={!satisfyRequirement.validateMoreThan8Characters ? 'light' : 'error'}
                        >
                            • At least 8 characters
                        </Text>
                        <Text variant={'p3'} color={!satisfyRequirement.validateOneLowerCase ? 'light' : 'error'}>
                            • At least one lowercase letter
                        </Text>
                        <Text variant={'p3'} color={!satisfyRequirement.validateOneUpperCase ? 'light' : 'error'}>
                            • At least one uppercase letter
                        </Text>
                        <Text variant={'p3'} color={!satisfyRequirement.validateOneNumber ? 'light' : 'error'}>
                            • At least one number
                        </Text>
                        <Text variant={'p3'} color={!satisfyRequirement.validateOneSpecial ? 'light' : 'error'}>
                            • At least one special character
                        </Text>
                    </Stack>
                    <PasswordInput
                        data-cy={'account-creation-confirm-password'}
                        error={Boolean(errors.confirmPassword)}
                        helperText={errors.confirmPassword}
                        label={'Confirm Password'}
                        onChange={(e) => handleChange('confirmPassword', e.target.value)}
                        placeholder={'Enter new password'}
                        value={form.confirmPassword}
                        autoComplete={'off'}
                        required
                    />
                </InputStack>
                <ButtonStack direction={'row'} justifyContent={'space-between'}>
                    <Button
                        color={'neutral'}
                        onClick={() => handlePrev(PAGES.NAME)}
                        startIcon={<Icon kind={'arrowLeft'} />}
                        variant={'tertiary'}
                    >
                        Back
                    </Button>
                    <Button data-cy={'account-creation-next-button'} size={'medium'} type={'submit'}>
                        Next
                    </Button>
                </ButtonStack>
            </Form>
        </VerifyEmailBox>
    );
};

const VerifyEmailBox = styled(Box)(({ theme, device }) => {
    return {
        marginTop: theme.spacing(12),
        padding: device === 'mobile' ? 0 : theme.spacing(7),
        width: device === 'mobile' ? '100%' : 450,
        height: 'fit-content',
        background: device === 'mobile' ? 'transparent' : theme.palette.ensightful.shades[0],
        boxShadow: device === 'mobile' ? 'none' : theme.palette.ensightful.shadows[1],
        borderRadius: '12px',
    };
});

const InputStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 2, 0),
        gap: theme.spacing(4),
    };
});

const ButtonStack = styled(Stack)(({ theme }) => {
    return {
        margin: theme.spacing(6, 0, 3, 0),
    };
});

export default PasswordInputs;
